// extracted by mini-css-extract-plugin
module.exports = {"table":"BetsTable_table__NaTku","tr":"BetsTable_tr__suCPy","scroll":"BetsTable_scroll__mbYfA"};